
<template>
  <div class="tab">
    <van-dropdown-menu >
        <div v-for="(item,index) in tabsList" :key="index" >
        <van-dropdown-item v-if="item.type=='timePicker'" :ref='item.label' :title="item.title">
            <van-datetime-picker
                v-model="item.value"
                type="year-month"
                :title="item.title"
                :min-date="item.minDate"
                :max-date="item.maxDate"
                :formatter="formatter"
                @confirm='getDate(item.label,index)'
                
            />
        </van-dropdown-item>
        <van-dropdown-item v-else :ref='item.label' @change='change(item.label,item.value)' :title="item.title" v-model="item.value" :options="item.items" >
        </van-dropdown-item>
        </div>

        <!-- <van-dropdown-item :change='change("type",type)' title="客户类型" v-model="type" :options="optionsType" />
        <van-dropdown-item  title="产品版本" v-model="product" :options="optionsType" />
        <van-dropdown-item v-model="sort" title="排序" :options="optionsType" /> -->
    </van-dropdown-menu>
  </div>
</template>

<script type="text/babel">
// 组件
import {formatDate} from '@/utils/cloud-utils.js'
export default {
  name: 'Tabs',
  props:{
      tabsList:{
          type: Array,
          default: () => {
              return []
          }
      },
  },
  data() {
    return {
        type:'',
        product:'',
        sort:'',
        currentDate:new Date(),
        optionsType:[
            {
                text:'全部',
                value:'0'
            },{
                text:'第一张',
                value:'1'
            },{
                text:'第二种',
                value:'2'
            },{
                text:'全部',
                value:'3'
            }
        ]
    };
  },
  created() {},
 mounted() {
 },
  methods: {
      change(type,value) {
          this.$emit('change',{type,value})
      },
        formatter(type, val) {
        if (type === 'year') {
            return `${val}年`;
        } else if (type === 'month') {
            return `${val}月`;
        }
        return val;
        },
        getDate(ref,index) {
            console.log(this.tabsList[0])
            this.$refs[ref][0].toggle();
            console.log(formatDate(this.tabsList[index].value, 'yyyy-MM'))
            this.change(ref, formatDate(this.tabsList[index].value, 'yyyy-MM'))
        }
  }
  
};
</script>

<style scoped lang="less">
.settle{
    background-color: @colorBg;
}

</style>
